import { descartarOrgDaAba } from '@/contexts/orgDaAba';

export const cleanupAuthState = () => {
  // Org escolhida só para esta aba (`?org=`, ver orgDaAba.ts): não pode passar para a próxima
  // sessão, que pode ser de outra pessoa.
  descartarOrgDaAba();
  try {
    // Remove standard Supabase auth tokens
    localStorage.removeItem('supabase.auth.token');

    // Remove all Supabase-related keys from localStorage
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
        localStorage.removeItem(key);
      }
    });

    // Remove from sessionStorage as well
    Object.keys(sessionStorage || {}).forEach((key) => {
      if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (e) {
    // no-op
  }
};
